import { useMsal } from "@azure/msal-react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import "./TeaserDataDisplay.css";
import TeaserSubmissionPopup from "./TeaserSubmissionPopup";
const TeaserDataDisplay = ({
  mailerParent,
  mailerChild,
  programNameTeaser,
  setIsTeaserMailGenerationClicked,
  categoryNameTeaser,
  handleReset,
  setIsTeaserNavigatedToForm,
  setIsTeaserMailGenerated
}) => {
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [userID, setUserID] = useState(null);
  const [open, setOpen] = useState(false);
  const isSubmitted = useSelector(state => state.model.isSubmitted);
  const isTeaserLoaded = useSelector(state => state.teaser.isTeaserLoaded);
  const teaserMail = useSelector(state => state.teaser.teaserMail);
  const dispatch = useDispatch();
  useEffect(() => {
    if (activeAccount) {
      setUserID(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);
  useEffect(() => {
    const handleCopy = event => {
      event.preventDefault();
      alert("Copying is disabled on this page!");
    };
    console.log("inherecopy");
    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
  return <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isTeaserLoaded && <Box display="flex" flexDirection="column" alignItems="center" sx={{
              height: "100%",
              justifyContent: "center"
            }}>
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>}
       {isTeaserLoaded && teaserMail != "" && <Stack spacing={2} sx={{
              padding: "0px",
              background: "white"
            }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div className="migrated-style-teaserdatadisplay-352148-1">
          <Markdown>{teaserMail}</Markdown>
         </div>
        </Stack>}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isTeaserLoaded && <Button variant="outlined" sx={{
                marginRight: "10px"
              }} disabled={isSubmitted ? true : false} onClick={() => {
                setOpen(true);
              }}>
          Submit For Approval
         </Button>}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p onClick={() => {
            setIsTeaserMailGenerationClicked(false);
            // dispatch(handleTeaserLoading());
            setIsTeaserNavigatedToForm(true);
            setIsTeaserMailGenerated(null);
          }}>
       {"<"} Back
      </p>
     </div>
     <TeaserSubmissionPopup open={open} setOpen={setOpen} userID={userID} mailerParent={mailerParent} mailerChild={mailerChild} modalResponse={teaserMail} categoryNameTeaser={categoryNameTeaser} handleReset={handleReset} programNameTeaser={programNameTeaser} />
    </div>
   </div>
  </>;
};
export default TeaserDataDisplay;
